import { api, unwrap } from "./httpClient";
import type {
  CreateProjectPayload,
  Project,
  UpdateProjectPayload,
} from "../types/api";

export const listProjects = () =>
  unwrap<Project[]>(api({ method: "GET", url: "/projects" }));

export const getProjectById = (projectId: number) =>
  unwrap<Project>(api({ method: "GET", url: `/projects/${projectId}` }));

export const createProject = (payload: CreateProjectPayload) =>
  unwrap<Project>(api({ method: "POST", url: "/projects", data: payload }));
export const updateProject = (
  projectId: number,
  payload: UpdateProjectPayload
) =>
  unwrap<Project>(
    api({ method: "PATCH", url: `/projects/${projectId}`, data: payload })
  );

export const deleteProject = (projectId: number) =>
  api({ method: "DELETE", url: `/projects/${projectId}` });

